import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CareersPage() {
  const navigate = useNavigate();

  return (
    <Box
      component="section"
      id="career"
      sx={{
        backgroundColor: "#F7FAFF",
        py: { xs: 6, md: 10 },
        display: "flex",
        justifyContent: "center",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {/* OUTER CONTAINER */}
      <Box sx={{ px: { xs: 2, sm: 4, md: "250px" }, width: "100%" }}>

        {/* ================= HEADING ================= */}
        <Box sx={{ mb: 6, textAlign: "center" }}>
          <Typography
            component="h1"
            sx={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2d2075",
              lineHeight: 1.5,
              mb: 1,
            }}
          >
            Careers
          </Typography>

          <Box
            sx={{
              width: 90,
              height: "3px",
              backgroundColor: "#2d2075",
              borderRadius: "2px",
              mx: "auto",
            }}
          />
        </Box>

        {/* ================= WHITE CARD ================= */}
        <Paper
          elevation={2}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: "2px",
            textAlign: "left",        
          }}
        >
          <Typography
            component="p"
            sx={{
              fontSize: "20px",
              color: "#444",
              lineHeight: 1.6,
              mb: 3,
            }}
          >
            At Multitex, we shape the future through advanced filtration
            engineering and world-class project execution. We respect
            diversity and follow an open-door hiring policy.
          </Typography>

          <Typography
            component="p"
            sx={{
              fontSize: "20px",
              color: "#444",
              lineHeight: 1.6,
              mb: 5,
            }}
          >
            Our workplace encourages innovation, career growth, leadership
            and continuous learning. We provide challenging and inspiring
            opportunities that help individuals grow both personally and
            professionally.
          </Typography>

          {/* ================= CTA ================= */}
          <Box sx={{ textAlign: "center" }}>
            <Button
              aria-label="View job openings at Multitex"
              variant="contained"
              onClick={() => navigate("/careers/job-openings")}
              sx={{
                backgroundColor: "#2d2075",
                px: 4,
                py: 1.5,
                fontSize: "16px",
                fontWeight: 600,
                borderRadius: "2px",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#2d2075",
                },
              }}
            >
              View Job Openings
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
